const appName = 'GoGoX Business'

const setDocumentTitle = title => {
  document.title = `${title} | ${appName}`
}

export { setDocumentTitle }
